import { Pipe, PipeTransform, inject } from '@angular/core';
import { AysUser } from '@bindoc-projects/resource-domain-lib';
import { BdPermissionsUsersService } from './users.service';
import { firstValueFrom } from 'rxjs';

@Pipe({
  name: 'user',
  standalone: true,
})
export class BdPermissionUserPipe implements PipeTransform {
  private _usersService = inject(BdPermissionsUsersService);


  transform(value: string): Promise<AysUser | null> {
    return firstValueFrom(this._usersService.getById(value));
  }
}
